import {ReactNode} from 'react';
import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {Typography} from '~library/atoms/Typography';
import './UpsellModal.sass';

export const Step1UpsellCopyABTestDetails = (className: string = ''): ReactNode => {
  const isMediumAndUp = useIsMediumAndUp();
  return (
    <div className={className}>
      <Typography variant="paragraph2" color="pebble" className="upsell-modal__step1-text">
        You've selected a Premium feature — that's a nice touch.{isMediumAndUp ? <br /> : ' '}
        Switch to Premium now to keep those special customizations.
      </Typography>
    </div>
  );
};
